// extracted by mini-css-extract-plugin
export default {"overdueAmount":"OverduePayments_overdueAmount"};